module.exports = __webpack_public_path__ + "img/Cargo.3ca1a984.svg";